"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CreateModel',
  inject: ['appParent'],
  props: {
    dialogStatus: {
      type: String,
      default: 'create'
    },
    isShow: {
      type: Boolean,
      default: false
    },
    brand: {
      type: String,
      default: 'ANDROID'
    }
  },
  data: function data() {
    var _this = this;
    var validateAppPlatformType = function validateAppPlatformType(rule, value, callback) {
      if (!value) {
        callback(new Error(_this.$t('sfe.appVersion.error.appPlatformType')));
      } else if (_this.errorKeys.indexOf('appPlatformType') >= 0) {
        callback(new Error(_this.errorInfo['appPlatformType']));
        _this.resetError('appPlatformType');
      } else {
        callback();
      }
    };
    var validateDisplayVersion = function validateDisplayVersion(rule, value, callback) {
      if ((0, _validate.validRule1)(value)) {
        callback(new Error(_this.$t('sfe.appVersion.error.displayVersion')));
      } else if (_this.errorKeys.indexOf('displayVersion') >= 0) {
        callback(new Error(_this.errorInfo['displayVersion']));
        _this.resetError('displayVersion');
      } else {
        callback();
      }
    };

    // const validateAppBizType = (rule, value, callback) => {
    //   if (!value) {
    //     callback(new Error('请选择'))
    //   } else if (this.errorKeys.indexOf('appBizType') >= 0) {
    //     callback(new Error(this.errorInfo['appBizType']))
    //     this.resetError('appBizType')
    //   } else {
    //     callback()
    //   }
    // }

    // const validateDownloadUrl = (rule, value, callback) => {
    //   if (!validURL(value)) {
    //     callback(new Error(this.$t('sfe.appVersion.error.downloadUrl')))
    //   } else if (this.errorKeys.indexOf('downloadUrl') >= 0) {
    //     callback(new Error(this.errorInfo['downloadUrl']))
    //     this.resetError('downloadUrl')
    //   } else {
    //     callback()
    //   }
    // }
    //
    // const validateVersionDesc = (rule, value, callback) => {
    //   if (validRule1(value)) {
    //     callback(new Error(this.$t('sfe.appVersion.error.versionDesc')))
    //   } else if (this.errorKeys.indexOf('versionDesc') >= 0) {
    //     callback(new Error(this.errorInfo['versionDesc']))
    //     this.resetError('versionDesc')
    //   } else {
    //     callback()
    //   }
    // }
    return {
      formLabelWidth: '120px',
      form: {},
      initForm: {},
      rules: {
        appPlatformType: [{
          required: true,
          validator: validateAppPlatformType,
          trigger: ['change']
        }],
        displayVersion: [{
          required: true,
          validator: validateDisplayVersion,
          trigger: ['change']
        }]
        // appBizType: [{ required: true, validator: validateAppBizType, trigger: ['change'] }],
        // downloadUrl: [{ required: true, validator: validateDownloadUrl, trigger: ['change'] }],
        // versionDesc: [{ required: true, validator: validateVersionDesc, trigger: ['change'] }]
      },
      errorKeys: [],
      errorInfo: {},
      fileList: [],
      apk: null,
      isHideUploadIcon: false
    };
  },
  computed: {
    isShowModel: {
      get: function get() {
        return this.isShow;
      },
      set: function set(val) {
        this.$emit('update:isShow', val);
      }
    }
  },
  watch: {
    isShowModel: function isShowModel(val) {
      var _this2 = this;
      if (val) {
        this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), this.appParent.form);
        this.initForm = (0, _objectSpread2.default)({}, this.form);
      } else {
        this.form = (0, _objectSpread2.default)({}, this.appParent.form);
        this.apk = null;
        this.isHideUploadIcon = false;
        this.fileList = [];
        // this.$refs.upload.value = ''
        this.$nextTick(function () {
          _this2.$refs['dataForm'].clearValidate();
        });
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    handleRemove_apk: function handleRemove_apk(file, fileList) {
      var _this3 = this;
      this.fileList = [];
      this.form.downloadUrl = '';
      this.form.attribute1 = '';
      this.apk = null;
      setTimeout(function () {
        _this3.isHideUploadIcon = false;
      }, 500);
    },
    handleChange_apk1: function handleChange_apk1(e) {
      var file = e.target.files || e.dataTransfer.files;
      console.log('file----', file);
      this.apk = file[0];
      if (this.apk) {
        this.isHideUploadIcon = true;
        this.uploadFile();
      } else {
        this.$message.error(this.$t('sfe.appVersion.error.uploadFail'));
        this.isHideUploadIcon = false;
        this.apk = null;
      }
    },
    handleChange_apk: function handleChange_apk(file, fileList) {
      console.log(file);
      this.apk = file.raw;
      if (this.apk) {
        this.isHideUploadIcon = true;
        this.uploadFile();
      } else {
        this.$message.error(this.$t('sfe.appVersion.error.uploadFail'));
        this.isHideUploadIcon = false;
        this.apk = null;
      }
    },
    uploadFile: function uploadFile() {
      var _this4 = this;
      var businessType = '';
      if (this.form.appPlatformType === 'IOS') {
        businessType = 'app_ios';
      } else {
        businessType = 'app_android';
      }
      var param = new FormData();
      param.append('file', this.apk);
      param.append('resourceConfigFlag', businessType);
      this.appParent.isLoading = true;
      this.$api.common.uploadFile(param).then(function (res) {
        _this4.appParent.isLoading = false;
        _this4.form.downloadUrl = res.data && res.data.url;
        _this4.form.attribute1 = res.data && res.data.uuid;
        _this4.isHideUploadIcon = true;
      }).catch(function () {
        _this4.appParent.isLoading = false;
        _this4.isHideUploadIcon = false;
        _this4.apk = null;
        _this4.form.downloadUrl = '';
        _this4.form.attribute1 = '';
      });
    },
    saveItem: function saveItem() {
      var _this5 = this;
      console.log(this.form);
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        _this5.appParent.isLoading = true;
        _this5.$api.appVersion.saveItem2(_this5.form).then(function (res) {
          _this5.appParent.isLoading = false;
          _this5.isShowModel = false;
          _this5.appParent.fetchData();
        }).catch(function (err) {
          if (err.errorInfos && err.errorInfos.length > 0) {
            _this5.resetError();
            err.errorInfos.forEach(function (item) {
              _this5.errorKeys.push(item.key);
              _this5.errorInfo[item.key] = item.errMsg;
            });
            _this5.$refs['dataForm'].validate(function (valid) {
              console.log(valid);
            });
          }
          _this5.appParent.isLoading = false;
          // this.$message.error('保存失败')
        });
      });
    },
    resetError: function resetError(val) {
      if (val) {
        var index = this.errorKeys.indexOf(val);
        this.errorKeys.splice(index, 1);
        delete this.errorInfo.val;
      } else {
        this.errorKeys = [];
        this.errorInfo = {};
      }
    }
  }
};